<template>
  <div class="mb-10">
    <VRow align-content="space-between" class="align-baseline">
      <VCol class="pt-0 pt-md-2">
        <PageTitle
          no-border
          tag="h1"
          level="2"
          class="mb-0"
        >
          <span class="d-none d-md-inline font-weight-light">
            {{ $t('vacancy') }}: </span>{{ vacancy.title || '' }}
        </PageTitle>
      </VCol>
      <VCol cols="1" align="right" class="d-none d-md-block">
        <span class="progress-value">{{ progress }}%</span>
      </VCol>
    </VRow>
    <VProgressLinear :value="progress" />
    <PageTitle
      tag="h2"
      level="2"
      class="step-heading d-none d-md-block mt-4 mb-1"
      no-border
    >
      {{ $t('step') }} {{ currentStep }}: <slot />
    </PageTitle>
    <slot name="description" />
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle';
import Wizard from '@/orm/models/Wizard/Wizard';
import { computed } from '@vue/composition-api';

export default {
  name: 'VacancyStepTitle',
  components: { PageTitle },
  props: {
    vacancy: {
      type: Object,
      default: () => {},
    },
    progress: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const currentStep = computed(() => {
      if (props.step !== null && props.step !== undefined) {
        return props.step;
      }
      const curRoute = Wizard.findCurrentRoute();
      return curRoute?.stepNumber;
    });
    return {
      currentStep,
    };
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
  vacancy: Job
  step: Step
</i18n>

<i18n locale="ru" lang="yaml">
  vacancy: Вакансия
  step: Шаг
</i18n>
